<template>
  <div class="relative flex max-w-full">
    <svg
      v-if="!hide"
      :id="`prev-caret-${uid}`"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 10 24"
      stroke="currentColor"
      class="flex-none h-10 my-auto mr-1 cursor-pointer"
      :class="{ 'md:hidden': !allResolution }"
      @click="navigate && navigate(-1)"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M8 19l-7-7 7-7"
      />
    </svg>
    <slot />
    <svg
      v-if="!hide"
      :id="`next-caret-${uid}`"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 10 24"
      stroke="currentColor"
      class=" flex-none h-10 my-auto ml-1 cursor-pointer"
      :class="{ 'md:hidden': !allResolution }"
      @click="navigate && navigate(+1)"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M1 5l7 7-7 7"
      />
    </svg>
  </div>
</template>

<script>
export default {
  props: {
    navigate: Function,
    allResolution: Boolean,
    uid: { required: true },
    hide: Boolean
  }
};
</script>
<style lang="postcss" scoped>
.swiper-button-disabled,
[aria-disabled="true"] {
  @apply invisible;
}
</style>
